// Specifies mime types of allowed files
// however not all browsers will prevent other
// file types being uploaded: https://caniuse.com/?search=input-file-accept

export const DEFAULT_FILE_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpg",
  "image/jpeg",
];

export const DEFAULT_MAX_FILE_SIZE = 10 * 1000 * 1000;

export function formatFileSize(bytes?: number, decimalPoints = 0) {
  if (!bytes) {
    return undefined;
  }

  const thresh = 1000;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let u = -1;
  const r = 10 ** decimalPoints;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(decimalPoints) + " " + units[u];
}

const UPLOAD_UUID_PREFIX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i;

/** The file name without the folders or the `<uuid>-` prefix added on upload. */
export function getOriginalFileName(fileNameOrKey: string) {
  const basename = fileNameOrKey.split("/").filter(Boolean).pop() ?? "";
  return basename.replace(UPLOAD_UUID_PREFIX, "") || basename;
}

export function truncatedFileName(filename: string) {
  const fileTypePlusThreeChars = filename.substring(
    filename.lastIndexOf(".") - 3,
    filename.length
  );
  return [filename.replace(fileTypePlusThreeChars, ""), fileTypePlusThreeChars];
}

export function formatFileTypes(types?: string[] | null) {
  if (!types) {
    return [];
  }

  return types.map((type) => {
    const parts = type.split("/");
    if (parts[1]) {
      const isDocx =
        parts[1] ===
        "vnd.openxmlformats-officedocument.wordprocessingml.document";

      if (isDocx) return "DOCX";

      return parts[1].toUpperCase();
    }

    return type;
  });
}
